import React, {useEffect, useState} from "react";
import { elastic as Menu } from "react-burger-menu";
import "./SideBar.css"
import {useDispatchNav, useNav, useUser} from "../../hooks";
import SimpleLineIcon from "react-simple-line-icons";
import {useHistory} from "react-router-dom";
import {useMall} from "../../hooks/useMall";
import {getMallMerchant_api} from "../../Services/apis";

const SideBar =  props => {

    //Hooks

    const nav = useNav();
    const setNav = useDispatchNav();
    const history = useHistory()
    const mall = useMall();
    const user = useUser();


    // states
    const [mallName,setMallName]= useState("");
    const [subState,set_SubState]= useState(false);



    //Func

    const handleOnClose = ()=> setNav(false);

    const goTo = (page) =>  {
        setNav(false);
        history.push(`/${page}`);
    }

    const goToRoot = (page) =>  {
        setNav(false);
        history.push(`/${page}`);
    }



    const handleProfileName = () =>  {
        let localUser = localStorage.getItem('user');
        if(localUser){localUser = JSON.parse(localUser);}

        let userObj = localUser?localUser:user;
        if (userObj){
            if(userObj.first_name){
                return userObj.first_name+" "+userObj.last_name;
            }else {
                return "بدون نام";
            }
        }else {
            return "بدون نام";
        }
    }

    const handleProfilePhone = () =>  {
        let localUser = localStorage.getItem('user');
        if(localUser){localUser = JSON.parse(localUser);}
        let userObj = localUser?localUser:user;
        if (userObj){
            if(userObj.phone){return userObj.phone;}
        }else {
            return "بدون شماره";
        }
    }

    const handleProfileImage = () =>  {
        let localUser = localStorage.getItem('user');
        if(localUser){localUser = JSON.parse(localUser);}
        let userObj = localUser?localUser:user;
        if (userObj){
            if(userObj.image){return userObj.image;}
        }else {
            return "/other/profile-default-icon.png";
        }
    }

    const logout = () =>{
        localStorage.removeItem('mallId');
        localStorage.removeItem('merchants');
        localStorage.removeItem('mallLogo');
        localStorage.removeItem('mallWhite');
        localStorage.removeItem('mallName');
        localStorage.removeItem('mall');
        localStorage.removeItem('user');
        localStorage.removeItem('cats');
        localStorage.removeItem('wait');
        localStorage.removeItem('token');
        localStorage.removeItem('shop_token');
        localStorage.removeItem('allowNotif');
        localStorage.removeItem('basket');
        localStorage.removeItem('mobileSuggestion');
        localStorage.removeItem('active_tab');
        setNav(false)
        history.push('/login');
    }

    const dial = () =>{
        let mall = localStorage.getItem('mall');
        if(mall){
            let parsedMall = JSON.parse(mall);
            console.log(parsedMall);
            if(parsedMall.phone)
                document.location.href=`tel:${parsedMall.phone}`;
        }

    }

    useEffect(()=>{
        checkSubDomain()
       let mallN =  localStorage.getItem('mallName');
       if(mallN){setMallName(mallN)}
    },)


    const checkSubDomain = ()=>{
        let full = window.location.hostname; // subdomain.domain.com
        let parts = full.split('.');
        let sub = parts[0];

        if(sub==="www" || sub==="test")
            sub = parts[1];


        if(sub==="digimaall" || sub==="test" || sub==="stage" || sub==="localhost" || sub==="apluss" || sub==="app"){
            sub = "digimaall"
        }

        if(sub!=="digimaall"){
            set_SubState(false)
        }else {
            set_SubState(true)
        }
    }


    const [merchant,set_merchant] = useState({})

    useEffect(()=>{
        if(!props.responsive){
            getMallMerchant()
        }
    },[mall])

    const getMallMerchant = async()=>{
        try{
            const res = await getMallMerchant_api()
            set_merchant(res.data)
        }catch(e){
            console.log(e)
        }
    }
    return (
        <Menu right  onClose={ handleOnClose } isOpen={ nav }   customBurgerIcon={ false }>
            <div className="side-profile-sec">
                <div className="side-profile-card" onClick={()=>{
                    goTo("profile")
                }}>
                    <div className="side-profile-info">
                        <span className="profile-name">{handleProfileName()}</span>
                        <div className="wallet">
                            <span>{handleProfilePhone()}</span>
                        </div>
                    </div>
                    <div className="side-profile-img">
                        <img src={handleProfileImage()} alt=""/>
                    </div>
                </div>
                {/*<div className="wallet-inc">*/}
                {/*    <div className="wallet-inc-btn">*/}
                {/*        <span>افزایش موجودی</span>*/}
                {/*        <i className="fa fa-plus-square-o"></i>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {subState ?<div className="choose-mall" onClick={()=>goTo('malls')}>
                    <SimpleLineIcon name="arrow-left"/>
                    <div className="choose-mall-info">
                        <span className="choose-mall-info-label">انتخاب مرکز خرید</span>
                        <span className="choose-mall-info-mallName">{mallName}</span>
                    </div>
                </div>:null}



                <div className="side-menu-list">
                    {/*<div className="side-menu-items">*/}
                    {/*    <span>تنظیمات</span>*/}
                    {/*    <SimpleLineIcon name="equalizer"/>*/}
                    {/*</div>*/}

                    <div className="side-menu-items" onClick={()=>{goToRoot('festivals')}}>
                        <span>جشنواره ها</span>
                        <SimpleLineIcon name="calendar"/>
                    </div>

                    {/*<div className="side-menu-items">*/}
                    {/*    <span>درباره دیجیمال</span>*/}
                    {/*    <SimpleLineIcon name="energy"/>*/}
                    {/*</div>*/}

                    {/*<div className="side-menu-items" onClick={()=>{goToRoot('events')}}>*/}
                    {/*    <span>رویدادها</span>*/}
                    {/*    <SimpleLineIcon name="share"/>*/}
                    {/*</div>*/}

                    <div className="side-menu-items" onClick={() => {
                        if (merchant.uid) {
                            setNav(false);
                            history.push(`/referral/${merchant.uid}`, {item:merchant})
                        }
                    }}>
                        <span>دعوت از دوستان</span>
                        <SimpleLineIcon name="book-open"/>

                    </div>

                    <div className="side-menu-items" onClick={()=>{goToRoot('scan')}}>
                        <span>اسکن </span>
                        <SimpleLineIcon name="frame"/>

                    </div>

                    <div className="side-menu-items" onClick={()=>{goToRoot(`faq/${merchant.uid}`)}}>
                        <span>سوالات متداول </span>
                        <SimpleLineIcon name="book-open"/>

                    </div>

                    <div className="side-menu-items" onClick={dial}>
                        <span>تماس </span>
                        <SimpleLineIcon name="people"/>
                    </div>

                    <div className="side-menu-items" onClick={()=>{goToRoot('about')}}>
                        <span>درباره ما</span>
                        <SimpleLineIcon  name="people"/>
                    </div>



                    {/*<div className="side-menu-items">*/}
                    {/*    <span>صندوق مجازی</span>*/}
                    {/*    <SimpleLineIcon name="handbag"/>*/}
                    {/*</div>*/}
                    <div className="side-menu-items" onClick={()=>{logout()}}>
                        <span>خروج از حساب کاربری</span>
                        <SimpleLineIcon name="logout"/>
                    </div>

                </div>

            </div>




            {/*<a className="menu-item" href="/">*/}
            {/*    Home*/}
            {/*</a>*/}

            {/*<a className="menu-item" href="/burgers">*/}
            {/*    Burgers*/}
            {/*</a>*/}

            {/*<a className="menu-item" href="/pizzas">*/}
            {/*    Pizzas*/}
            {/*</a>*/}

            {/*<a className="menu-item" href="/desserts">*/}
            {/*    Desserts*/}
            {/*</a>*/}
        </Menu>
    );
};

export {SideBar};
